$(function() {
	if (!$body.hasClass('single-room'))
		return;

	var isRoom = $('body').hasClass('single-room');

	var slider = $('.room_hero .slides');

	var slides = slider.find('.slide');
	initializeSlick(slider, {
		accessibility: true,
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		arrows: true,
		autoplay: false,
		fade: true,
		pauseOnFocus: true,
		pauseOnHover: false,
		nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>',
		focusOnSelect: true,
	}, function() {
		slider.on('beforeChange', function() {
			$('.room_hero .darken').addClass('hide');
			$('.room_hero .darken_alternate').addClass('show');
			$('.room_hero .title').addClass('hide');
		});
	});

	slider.on('afterChange', function(e, slick) {
		slides.eq(0).removeClass('initial_load');
		slides.removeClass('current_slide').eq(slick.currentSlide).addClass('current_slide');
	});

	$(window).on('panelsLoaded', function() {
		setTimeout(function() {
			slides.eq(0).addClass('initial_load');
			if (window.currentSlidersState != 2) {
				slider.slick('slickPlay');
			} else {
				slider.data('autoplay', 1);
			}			
		}, 500);
	});

	if ($('.single-room').length) {
		// Keep menu on screen as long as it doesn't overlap footer
		$(window).load(function() {
			var roomHero = $('.room_hero');
			var roomContent = $('.room_content');
			var contentTop = roomContent.length ? roomContent.offset().top : 0;
			var contentHeight = $('.room_content').outerHeight(true);
			var roomsNav = $('.room_nav');
			var roomsNavWrapper = $('.aside_wrapper');
			var roomsTop = $('.room_nav').offset().top;

			$(window).bind('mousewheel', function(event) {
				var contentTopInViewport = contentTop - $(window).scrollTop();
				var scrollTop = $(window).scrollTop();
				var roomsBottom = scrollTop + roomsNav.outerHeight(true);
				var contentBottom = roomContent.offset().top + contentHeight;
				var roomsTop = $('.room_nav').offset().top;

				if(contentHeight > roomsNav.outerHeight(true)){
					if (scrollTop < contentTop){
						roomsNavWrapper.removeClass('attached');
						roomsNavWrapper.css('bottom', '');
						roomsNavWrapper.css('top', '0');
						roomsNav.css('bottom', '');
					}
				    if (event.originalEvent.wheelDelta >= 0) {
				    	//user scrolling up
				    	if(scrollTop + 60 <= roomsTop && scrollTop + 60 > contentTop){
							roomsNavWrapper.addClass('attached');
							roomsNavWrapper.css('top', '');
						}
				    } else {
				    	// console.log(roomsBottom +' / '+ contentBottom)
				    	//user scrolling down
				        if(scrollTop + 60 >= contentTop && roomsBottom < contentBottom - 80){
							roomsNavWrapper.addClass('attached');
							roomsNavWrapper.css('top', '');
						} else if (scrollTop > contentTop) {
							roomsNavWrapper.removeClass('attached');
							roomsNavWrapper.css('top', '');
							roomsNavWrapper.css('bottom', '0');
							roomsNav.css('bottom', '20px');
						}
				    }
				} else {
					roomsNavWrapper.css('position', 'relative');
					roomsNav.css('position', 'relative');
					roomsNav.css('right', '0');
				}
			});
		})
	}

});